exports.statusesHash = {
	published: 'published',
	ready: 'ready',
	draft: 'draft',
	deleted: 'deleted'
};

exports.statusTitlesHash = {
	published: 'Опубликовано',
	ready: 'Готово к\u00A0публикации',
	draft: 'Черновик',
	deleted: 'Удалено'
};

exports.importEntityStatusesHash = {
	successful: 'successful',
	failed: 'failed'
};

exports.importEntityStatusTitlesHash = {
	successful: 'Успешно',
	failed: 'Ошибка'
};
